const state = {
  site: {},
  sites: [],
}

export default state
